import React from 'react';
import ReactDom from 'react-dom';
import Modal from '../modal/Modal';
import Icon from '../icon/Icon';
import { noop } from '../../js/utils';
import './toast.scss';

function toast({
  type,
  content,
  duration = 3,
  onClose = noop,
  icon,
  mask = true,
  bodyStyle,
  wrapClassName,
  clickClose = true
}) {
  let toastTimer = null;
  const div = document.createElement('div');

  function destroy() {
    clearTimeout(toastTimer);
    toastTimer = null;
    ReactDom.unmountComponentAtNode(div);
    document.body.removeChild(div);
  }

  document.body.appendChild(div);

  ReactDom.render(
    <Modal
      visible
      mask={mask}
      wrapClassName={['modal-toast', `modal-toast-${type}`, wrapClassName].join(' ')}
      bodyStyle={bodyStyle}
      maskClosable={clickClose}
      onClose={destroy}
    >
      <span>{content}</span>
      {icon}
    </Modal>,
    div,
    () => {
      if (duration) {
        toastTimer = setTimeout(() => {
          onClose();
          destroy();
        }, duration * 1000);
      }
    }
  );

  return {
    destroy
  };
}

export default {
  info(
    content,
    duration = 3,
    onClose
  ) {
    return toast({
      type: 'info',
      content,
      duration,
      onClose,
      icon: ''
    });
  },

  success(
    content,
    duration = 3,
    onClose
  ) {
    return toast({
      type: 'success',
      content,
      duration,
      onClose,
      icon: <Icon icon="dui1-copy-copy" />
    });
  },

  fail(
    content,
    duration = 3,
    onClose
  ) {
    return toast({
      type: 'fail',
      content: content instanceof Error ? content.toString() : content,
      duration,
      onClose,
      icon: <Icon icon="cuo" />
    });
  },

  loading(
    content = ''
  ) {
    return toast({
      type: 'loading',
      content,
      mask: true,
      duration: null,
      icon: <Icon icon="loading" />,
      clickClose: false
    });
  }
};
